import { render, staticRenderFns } from "./TeacherStatusCell.vue?vue&type=template&id=8ba86878"
import script from "./TeacherStatusCell.vue?vue&type=script&lang=js"
export * from "./TeacherStatusCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports